<template>
  <div class="parent_div">
    <dd-header />
    <div class="wrapper">
      <div class="main_content">
        <dd-menu ref="menuRef"/>
        <div>
          <dd-sitemap
            :pageKey="pageKey"
            :pageList="pageList"
            :mapStyle="'topic_path'"
          />
          <section id="order_bunner">
            <!-- <dd-banner
              ref="ddBannerListRef"
              :swipeList="bannerList"
              :swiperOptions="categoryOptions"
              :horizontalMode="false"
            /> -->
            <img :src="sketchBunnerGif" class="bunner_gif">
            <p>
              ラフなスケッチでも、ミリスタイルの担当が不明点をお電話などでご確認させていただきますのでご安⼼ください。<br>
              ミリスタイル専⽤のダロス⾃動⽣成クラウドを利⽤して、ミリスタイルスタッフがスケッチを参考に再プランニングすることで、<br>
              図⾯や⾒積書は全て⾃動的に⽣成しご提案させて頂きます。
            </p>
            <div>
              <div class="sketch_upload_btn">
                <img :src="getImage('top/sketch/sketchorder_start.png')" @click="goUpload">
              </div>
            </div>
          </section>
          <section>
            <h2>どこよりも早く、どこよりも低価格でご提供できる理由</h2>
            <div class="sketch_margin_img">
              <img :src="getImage('top/sketch/sketchorder_img01.png')">
            </div>
            <p>
              設計・製造データを⾃動⽣成する専用クラウドシステムdaros(ダロス）を活用することで、製品の設計から製造までの人的工数を大幅に削減しております。<br>
              その結果、一般的なオーダー家具と比較し、圧倒的な低価格・短納期で、製品の提供をしております。また、darosには充分な実績をもつオーダー家具の設計ルールがデジタルプログラム化されており、安心安全設計の製品を提供しております。
            </p>
            <img :src="getImage('top/sketch/sketchorder_img02.png')">
          </section>
          <section>
            <h2>darosとは</h2>
            <img :src="getImage('top/sketch/daros.gif')">
          </section>
          <section>
            <h2>どこよりも早く、どこよりも低価格でご提供できる理由</h2>
            <div class="sketch_sub_head">
              <h3>色柄 / 素材について</h3>
              <p>
                あらかじめ登録している素材の中からご要望にマッチするものを選択してご提供させて頂きます。<br>
                （住宅業界に大量に供給されている量的背景を持った素材をメインに採用しておりますので、オーダー家具でありながら量産品と同じ材料費でご提供が可能となりました。)
              </p>
              <div>
                <div><img /></div>
                <div><img /></div>
              </div>
              <div class="detail_btn5 btn_pos_center">色柄/素材見本帳請求</div>
            </div>
            <div class="sketch_sub_head">
              <h3>扇形状など、加工方法について</h3>
              <p>
                あらかじめ登録しているユニット類(扉や箱形状)の中からご要望にマッチするものを選択してご提案させて頂きます。<br>
                （住宅業界に大量に供給されている量産品に使用される各種ユニット形状と加工方法を採用しておりますので、オーダー家具でありながら量産品と同様の加工費でのご提供が可能となりました。さらに、加工安定性と安心安全設計を併せ持つ、量産可能なオーダー家具のご提供が可能となりました。)
              </p>
              <div>
                <img />
                <div>
                  <div>ユニット名:開き扉</div>
                  <div>素材:</div>
                  <div>形状:</div>
                  <div>板厚:</div>
                  <div>カラー:</div>
                </div>
              </div>
            </div>
            <div class="sketch_sub_head">
              <h3>ご注文について</h3>
              <p>
                スケッチを頂戴してご提案内容が決まりましたら、お客様の買い物かごにご提案内容を保存させて頂きます。<br>
                内容をご確認いただき、そのままmm/styleで購入いただけます。
              </p>
              <div>
                <img :src="getImage('top/sketch/sketchorder_img03.png')">
                <p class="sketch_img_center">スケッチオーダーのご注文フロー</p>
              </div>
              <div>
                <div class="sketch_upload_btn">
                  <img :src="getImage('top/sketch/sketchorder_start.png')" @click="goUpload">
                </div>
              </div>
            </div>
          </section>
          <div v-if="!isHaseko">
            <a href="tel:0362761123"><img :src="getImage('bunner/TEL.webp')"></a>
          </div>
        </div>
      </div>
    </div>
    <dd-footer />
  </div>
</template>
<script>
import * as App from '../../utils/App'
import * as AppEc from '../utils/AppEc'
import DcHeader from '../components/common/DcHeader'
import DcFooter from '../components/common/DcFooter'
import DDLeftMenu from '../components/top/DcLeftMenu'
import DcSiteMap from '../components/common/DcSiteMap'
import DcBannerSwiper from '../components/common/DcBannerSwiper'
import {DC_STORAGE_KEY, STRUCT_CORP_ID_ST, STRUCT_CORP_ID_ED} from '../../constants/App'

export default {
  components: {
    'dd-header': DcHeader,
    'dd-footer': DcFooter,
    'dd-menu': DDLeftMenu,
    'dd-sitemap': DcSiteMap,
    'dd-banner': DcBannerSwiper
  },
  data () {
    return {
      pageKey: 'dcSketchOrder',
      pageList: [
        {id: 'top', key: 'dcTop', title: 'トップページ', route: 'DcTop'},
        {id: 'sketchOrder', key: 'dcSketchOrder', title: 'スケッチオーダー', route: 'DcSketchOrder'}
      ],
      categoryOptions: {
        slidesPerView: 'auto',
        slidesPrGroup: 2,
        slidesPerColumn: 1,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        SimulateTouch: true,
        touchStartPreventDefault: false,
        preventClicks: true,
        centeredSlides: false,
        spaceBetween: 10,
        initialSlide: 0,
        loop: true,
        autoPlay: {
          delay: 3000,
          pauseOnMouseEnter: true
        }
      },
      bannerList: [
        {id: 1, img: this.getImage('bunner/sketch_order_banner_SO01.png'), route: 'DcSketchOrder', clickable: true},
        {id: 2, img: this.getImage('bunner/sketch_order_banner_SO02.png'), route: 'DcSketchOrder', clickable: true},
        {id: 3, img: this.getImage('bunner/sketch_order_banner_SO03.png'), route: 'DcSketchOrder', clickable: true},
        {id: 4, img: this.getImage('bunner/sketch_order_banner_SO05.png'), route: 'DcSketchOrder', clickable: true}
      ],
      user: {},
      sketchBunnerGif: this.getImage('bunner/sketch_order_banner_SO01.gif')
    }
  },
  computed: {
    isLogin: function () {
      if (!this.user || Object.keys(this.user).length <= 0) return false
      if (this.user.userId === undefined) return false
      if (this.user.userLevel === 4) return false
      return true
    },
    isHaseko: function () {
      return (this.user && this.user.corpId >= STRUCT_CORP_ID_ST && this.user.corpId <= STRUCT_CORP_ID_ED)
    }
  },
  methods: {
    getImage: function (image) {
      return App.getMmstyleResource(image)
    },
    goUpload: function () {
      if (this.isLogin) {
        this.$router.push({
          name: 'DcSketchUpload'
        })
      } else {
        AppEc.showModal({
          title: '',
          messages: ['スケッチアップロードはmm/style会員様限定の機能です。\n以下より会員登録、またはログインしご利用ください。'],
          messageType: 'success',
          layoutType: 'layout-classic',
          modalType: 'message',
          textAlign: 'center',
          okBtnLabel: '会員登録/ログインページへ',
          onOk: () => {
            let params = {type: 'sketch'}
            this.$router.push({
              name: 'DcOrderSignIn',
              params: params
            })
          },
          onCancel: () => {
          }
        })
      }
    },
    route: function (name, params) {
      this.$router.push({
        name: name,
        query: params
      })
    }
  },
  created: function () {
    this.user = App.getLocalStorage(DC_STORAGE_KEY.USER_INFO)
  }
}
</script>
<style src="../css/dc-mainmenu.scss" lang="scss" scoped></style>
<style src="../css/dctop4.scss" lang="scss" scoped></style>
<style src="../css/dc-sketch.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/main/js/payment/pages/DcSketchOrder.vue